import {
  BreakStyle,
  containerBorderRadius,
  defineStylesWithBreaks,
  inputField
} from 'notability-services-common-frontend'

export const tipInfoLeft = 30
export const tipInfoTop = -10

export const loginStyles = defineStylesWithBreaks((theme, font) => {
  const button: BreakStyle = {
    width: '100%',
    height: '44px',
    padding: '10px',
    border: 'none',
    fontSize: '20px',
    flexShrink: 1
  }

  const inputLabel: BreakStyle = {
    ...font.bodyBold,
    lineHeight: '21px',
    margin: 0,
    textAlign: 'left'
  }

  const heading: BreakStyle = {
    ...font.largeTitleBold,
    fontSize: '34px',
    lineHeight: '41px'
  }

  const body: BreakStyle = {
    ...font.body,
    color: theme.core.f3
  }

  const screennamePromptContainer: BreakStyle = {
    display: 'flex',
    flexDirection: 'column',
    width: '100%'
  }

  const formContainer: BreakStyle = {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    gap: '32px',
    flexShrink: 1,
    flexGrow: 2,
    padding: '40px',
    minHeight: '500px',
    maxWidth: '600px',
    borderRadius: containerBorderRadius,
    textAlign: 'center',

    md: {
      minHeight: 'unset'
    },

    mobile: {
      minHeight: 'unset'
    }
  }

  return {
    container: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      fontSize: '15px',
      fontStyle: 'normal',
      marginTop: '0px'
    },

    formContainer: {
      ...formContainer
    },

    form: {
      display: 'flex',
      flexDirection: 'column',
      gap: '32px'
    },

    linkSentContainerInner: {
      ...formContainer,
      textAlign: 'left',
      gap: '14px'
    },

    linkSentContainer: {
      display: 'flex',
      flexDirection: 'row',
      maxWidth: '80vw',
      alignItems: 'center',

      md: {
        flexDirection: 'column-reverse',
        justifyContent: 'center'
      },

      mobile: {
        flexDirection: 'column-reverse'
      }
    },

    linkSentImage: {
      maxHeight: 'calc(max(40vh,40vw))',
      maxWidth: 'calc(max(40vh,40vw))',

      md: {
        maxHeight: 'calc(max(40vh,40vw))',
        maxWidth: 'calc(max(40vh,40vw))'
      },

      mobile: {
        maxHeight: 'calc(max(20vh,20vw))',
        maxWidth: 'calc(max(20vh,20vw))'
      }
    },

    screennamePromptModalBox: {
      maxWidth: '400px'
    },

    screennamePromptContainer,

    screennamePromptContainerCenter: {
      ...screennamePromptContainer,
      alignItems: 'center'
    },

    body,

    button,

    buttonCentered: {
      ...button,
      alignSelf: 'center'
    },

    buttonDisabled: {
      ...button,
      cursor: 'default',
      background: theme.core.f3,
      color: theme.core.b1
    },

    input: {
      ...inputField(theme),
      borderRadius: '8px',
      margin: 0
    },

    forgotPassword: {
      ...font.bodyBold,
      color: theme.accent.base,
      textAlign: 'left'
    },

    footnote: font.caption,

    footnoteSpan: {
      color: theme.accent.base,
      paddingLeft: '5px',
      cursor: 'pointer'
    },

    inputLabel,

    inputLabelWithTip: {
      ...inputLabel,
      gap: '5px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start'
    },

    helpImageDiv: {
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      marginLeft: '5px',
      cursor: 'pointer',
      isolation: 'isolate'
    },

    errorText: {
      ...font.body,
      color: theme.alert.base
    },

    tipInfo: {
      display: 'flex',
      background: theme.accent.base,
      color: theme.accent.container,
      position: 'absolute',
      left: `${tipInfoLeft}px`,
      top: `${tipInfoTop}px`,
      padding: '15px',
      width: '230px',
      borderRadius: containerBorderRadius,
      fontSize: '14px',
      fontWeight: 'normal',
      zIndex: 1
    },

    tipCaret: {
      content: ' ',
      position: 'absolute',
      left: '-10px',
      top: '12px'
    },

    tipCaretColor: {
      color: theme.accent.base
    },

    mediumText: font.body,

    magicLinkExplainer: {
      ...font.body
    },

    ageVerification: {
      ...font.body,
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center'
    },

    ageVerificationRequired: {
      marginLeft: '8px',
      fontWeight: 'bold'
    },

    ageCheckBox: {
      transform: 'scale(1.5)',
      marginRight: '15px'
    },

    heading,

    headingCentered: {
      ...heading,
      alignSelf: 'center'
    },

    loadingSpinner: {
      width: '24px',
      height: '24px'
    },

    loadingSpinnerColor: {
      color: theme.core.f4
    },

    authTypeSwitch: {
      ...font.body,
      color: theme.core.f3
    },

    authTypeSwitchAction: {
      ...font.bodyBold,
      color: theme.accent.base,
      cursor: 'pointer'
    },
    authTypeSwitchActionDisabled: {
      ...font.bodyBold,
      color: theme.accent.containerPress,
      cursor: 'disabled'
    },

    tocLink: {
      ...font.body,
      fontSize: '15px',
      color: theme.core.f3,
      textDecoration: 'underline'
    },

    tocAgreement: {
      ...font.body,
      fontSize: '15px',
      color: theme.core.f3
    },

    illustration: {
      minWidth: '0px',
      flexShrink: 2,
      margin: 'auto'
    },

    separator: {
      height: '1px',
      background: theme.core.b4
    },

    hStack: {
      display: 'flex',
      flexDirection: 'column',
      gap: '12px'
    },

    alert: {
      color: theme.alert.base
    },

    formAlert: {
      ...body,
      color: theme.alert.base
    },

    betaHeader: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      gap: '7px',
      fontSize: '22px',
      fontWeight: 700,
      marginBottom: '20px'
    },

    loginMessageContainer: {},

    loginMessageHeader: {
      ...font.mediumTitleBold,
      marginBottom: 0
    },

    loginMessage: {
      ...font.body,
      marginBottom: '32px'
    }
  }
})
